/* eslint-disable max-lines */
import styled, { css } from "styled-components"
import { Regex } from "../../../../../../../constant/Regex"
import { Colors } from "../../../../../../../constant/Styled/Colors"
import { ItemRadio } from "../../../../../../../_webui/layout/components/Form/Item/Radio"
import { FormSearch } from "../../../../../../../_webui/layout/components/Form/Search"

const { FORM_ENTRY_BORDER } = Colors
const { REGEX_IS_DESKTOP } = Regex

const StyledItemAddon = styled.div`
  .ant-form-item-control-input-content {
    .ant {
      &-form-item {
        margin: 0;
        &-control {
          max-width: 100%;
        }
      }
      &-input {
        border: 1px solid ${FORM_ENTRY_BORDER};
        height: 40px;
        padding-left: 11px;
        &-affix-wrapper {
          flex: 1;
          width: 100%;
        }
        &-group {
          column-gap: 10px;
          &-addon {
            flex: 1;
            width: 100%;
          }
          &-wrapper {
            border: none;
            padding: 0;
          }
        }
      }
    }
  }
  ${!REGEX_IS_DESKTOP &&
  css`
    .ant-form-item-control-input-content {
      .ant {
        &-input {
          &-affix-wrapper {
            display: block;
          }
          &-group {
            &-addon {
              display: block;
              margin-bottom: 25px;
            }
            &-wrapper {
              height: initial;
            }
          }
        }
      }
    }
  `}
`

const StyledFormSearch = styled(FormSearch)`
  ${REGEX_IS_DESKTOP &&
  css`
    .ant-form-item-label {
      min-width: 130px;
    }
    #travelDate .ant-form-item {
      width: calc(50% - 17px);
      &-label {
        min-width: initial;
      }
    }
  `}
`

const StyledGroup = styled.div`
  ${REGEX_IS_DESKTOP &&
  css`
    display: flex;
    width: 100%;
    justify-content: space-between;
    .form-search {
      &-left {
        width: calc(40.75% + 90px);
      }
      &-right {
        width: calc(59.25% - 120px);
      }
    }
  `}
`

const StyledGroupLeft = styled.div`
  ${REGEX_IS_DESKTOP &&
  css`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: calc(100% - 220px);
    min-width: calc(100% - 220px);
    width: 100%;
  `}
`

const StyledGroupRight = styled.div`
  ${REGEX_IS_DESKTOP &&
  css`
    max-width: 220px;
    min-width: 220px;
  `}
`

const StyledItemRadio = styled(ItemRadio)`
  .ant {
    &-form-item-control {
      max-width: 100% !important;
    }
    &-radio {
      order: 1;
      &-group {
        display: block;
      }
      &-inner {
        margin-left: 10px;
        margin-right: 0;
      }
      &-wrapper {
        justify-content: space-between;
        margin-right: 0;
        width: 100%;
        &:first-child {
          text-transform: uppercase;
        }
        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
  }
`

export const Styled = {
  StyledFormSearch,
  StyledGroup,
  StyledGroupLeft,
  StyledGroupRight,
  StyledItemAddon,
  StyledItemRadio,
}
